
import React, { useState } from "react";

import Paper from '@mui/material/Paper';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Grid2 from '@mui/material/Grid2';

import PropTypes from 'prop-types';
import Login from "../components/login/Login";
import Signup from "../components/signup/Signup";
import { Toolbar } from "@mui/material";
import Verify from "../components/verify/Verify";
import AuthPageBackground from "../components/auth/AuthPageBackground";


const EntryVerify = () => {

  const [value, setValue] = React.useState(0);

    function CustomTabPanel(props) {
      const { children, value, index, ...other } = props;
  
      return (
        <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
        >
          {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
      );
    }
  
    CustomTabPanel.propTypes = {
      children: PropTypes.node,
      index: PropTypes.number.isRequired,
      value: PropTypes.number.isRequired,
    };
  
    function a11yProps(index) {
      return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    }
  

  return (
    <AuthPageBackground>
    <Grid2 spacing={2}>
      <Toolbar></Toolbar>
      <Grid2 display="flex" justifyContent="center" alignItems="center" size="grow" sx={{ marginTop: '50px', px: 2 }}>
        <Paper 
          elevation={0}
          sx={{
            borderRadius: 4,
            boxShadow: (theme) => theme.palette.mode === 'dark'
              ? '0 12px 40px rgba(0, 188, 212, 0.35), 0 0 0 1px rgba(0, 188, 212, 0.25)'
              : '0 12px 40px rgba(0, 151, 167, 0.15)',
            maxWidth: 450,
            width: '100%',
            overflow: 'hidden',
            backgroundColor: 'background.paper',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            animation: 'fadeIn 0.5s ease-in',
            '@keyframes fadeIn': {
              from: { opacity: 0, transform: 'translateY(20px)' },
              to: { opacity: 1, transform: 'translateY(0)' },
            },
          }}
        >
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} centered>
              <Tab label="Verification" {...a11yProps(0)} />
              </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <Verify/>
          </CustomTabPanel>
        </Paper>
        <br />
      </Grid2>
    </Grid2>
    </AuthPageBackground>
  );
};

export default EntryVerify;
